import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";

const Billing = () => {
  const [formData, setFormData] = useState({
  name: "",
  fatherName: "",
  motherName: "",
  class: "",
  session: "",
  amount: "",
  examinationFees: false,
  aadharNo: "",
  collegeRollNo: "",
  email: "",
  additionalSubject: "",
  addressLine: "",
  state: "",
  city: "",
  pincode: "",
  subject1: "",   // ✅ added
  subject2: "",   // ✅ added
});


  const [errorMessage, setErrorMessage] = useState("");

  // For state-city data:
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const navigate = useNavigate();


  useEffect(() => {
  const fetchStatesAndCities = async () => {
    try {
      const response = await fetch(
          "https://gist.githubusercontent.com/anubhavshrimal/4aeb195a743d0cdd1c3806c9c222ed45/raw/181a34db4fcb8b37533b7c8b9c489b6c01573158/Indian_Cities_In_States_JSON"
        );
      const data = await response.json();
      // Convert object -> array
      const arranged = Object.keys(data).map((stateName) => ({
        state: stateName,
        cities: data[stateName]
      }));
      setStateList(arranged);
    } catch (err) {
      console.error('Failed to load states data', err);
    }
  };

  fetchStatesAndCities();
}, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newVal = type === "checkbox" ? checked : value;
    setFormData((prev) => ({ ...prev, [name]: newVal }));

    // If state changes -> reset city and populate cityList
    if (name === "state") {
      setFormData((prev) => ({ ...prev, city: "" }));
      const stateObj = stateList.find((s) => s.state === value);
      setCityList(stateObj ? stateObj.cities : []);
    }
  };

  const validateInputs = () => {
    if (!formData.name) return "Name is required.";
    if (!formData.fatherName) return "Father's name is required.";
    if (!formData.motherName) return "Mother's name is required.";
    if (!["ANM", "GNM", "B.ED", "ITI"].includes(formData.class)) {
      return "Please select a valid class.";
    }
//     if (formData.class === "B.ED") {
//   if (!formData.subject1) return "Subject 1 is required for B.ED.";
//   if (!formData.subject2) return "Subject 2 is required for B.ED.";
// }
    if (!["2019", "2020", "2021", "2022", "2023", "2024","2025","2026"].includes(formData.session)) {
      return "Session must be between 2019 and 2026.";
    }
    // if (!formData.amount || isNaN(formData.amount) || Number(formData.amount) <= 10000) {
    //   return "Amount must be greater than 9999.";
    // }

    // Address validation:
    // if (!formData.addressLine) return "Address line is required.";
    // if (!formData.state) return "Please select a state.";
    // if (!formData.city) return "Please select a city.";
    // if (!formData.pincode || formData.pincode.length !== 6 || isNaN(formData.pincode)) {
    //   return "Pincode must be a 6-digit number.";
    // }

    if (formData.examinationFees) {
      if (!formData.aadharNo || formData.aadharNo.length !== 12 || isNaN(formData.aadharNo)) {
        return "Aadhar number must be a 12-digit numeric value.";
      }
      if (!formData.collegeRollNo) return "College roll number is required.";
      if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        return "Valid email is required.";
      }
      if (!formData.additionalSubject) return "Please select a subject.";
    }

    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateInputs();
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    setErrorMessage("");

    try {
      const response = await fetch("/billing", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        window.location.replace(result.url);
      } else {
        alert("Unexpected Error Occured. Please try again later");
      }
    } catch (error) {
      alert("Unexpected Error Occured. Please try again later");
    }
  };

  return (
    <div className="billing-form-container">
      <h2 className="form-title">Pay Your Fees</h2>
      <form className="billing-form" onSubmit={handleSubmit}>
        {errorMessage && <p className="error-message">{errorMessage}</p>}

        {/* Name, Father, Mother */}
        {/* (same as before) */}

        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter your name"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="fatherName">Father's Name</label>
          <input
            type="text"
            id="fatherName"
            name="fatherName"
            value={formData.fatherName}
            onChange={handleInputChange}
            placeholder="Enter your father's name"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="motherName">Mother's Name</label>
          <input
            type="text"
            id="motherName"
            name="motherName"
            value={formData.motherName}
            onChange={handleInputChange}
            placeholder="Enter your mother's name"
            required
          />
        </div>

        {/* Class, Session, Amount */}
        {/* (same as before) */}

        <div className="form-group">
          <label htmlFor="class">Class</label>
          <select
            id="class"
            name="class"
            value={formData.class}
            onChange={handleInputChange}
            required
          >
            <option value="">Select your class</option>
            <option value="ANM">ANM</option>
            <option value="GNM">GNM</option>
             <option value="B.ED">B.ED</option>
           {/* <option value="ITI">ITI</option>  */}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="session">Session</label>
          <select
            id="session"
            name="session"
            value={formData.session}
            onChange={handleInputChange}
            required
          >
            <option value="">Select your session</option>
            <option value="2019">2019</option>
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
          </select>
        </div>
            {/* B.ED Subjects */}
      {/* {formData.class === "B.ED" && (
        <>
          <div className="form-group">
            <label htmlFor="subject1">Subject 1</label>
            <input
              type="text"
              id="subject1"
              name="subject1"
              value={formData.subject1}
              onChange={handleInputChange}
              placeholder="Enter Subject 1"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject2">Subject 2</label>
            <input
              type="text"
              id="subject2"
              name="subject2"
              value={formData.subject2}
              onChange={handleInputChange}
              placeholder="Enter Subject 2"
              required
            />
          </div>
        </>
      )} */}

     

        {/* -------------------------------- */}
        {/* Address Section */}
        <div className="address-section">
          {/* <h3>Address Details</h3>

          <div className="form-group">
            <label htmlFor="addressLine">Address Line</label>
            <input
              type="text"
              id="addressLine"
              name="addressLine"
              value={formData.addressLine}
              onChange={handleInputChange}
              placeholder="Street / Locality"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="state">State</label>
            <select
              id="state"
              name="state"
              value={formData.state}
              onChange={handleInputChange}
              required
            >
              <option value="">Select State</option>
              {stateList.map((item) => (
                <option key={item.state} value={item.state}>
                  {item.state}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="city">City</label>
            <select
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              disabled={!formData.state}
              required
            >
              {!formData.state ? (
                <option value="">Select state first</option>
              ) : (
                <>
                  <option value="">Select City</option>
                  {cityList.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </>
              )}
            </select>
          </div> */}

            <div className="form-group">
          <label htmlFor="amount">Amount</label>
          <input
            type="number"
            id="amount"
            name="amount"
            value={formData.amount}
            onChange={handleInputChange}
            placeholder="Enter the amount"
            step="0.01"
            required
          />
        </div>
        </div>

        {/* -------------------------------- */}
        {/* Examination fee conditional fields (same) */}

        {/* <div className="form-group">
          <label>
            <input
              type="checkbox"
              name="examinationFees"
              checked={formData.examinationFees}
              onChange={handleInputChange}
            />
            Examination Fees
          </label>
        </div> */}

        {formData.examinationFees && (
          <>
            <div className="form-group">
              <label htmlFor="aadharNo">Aadhar Number</label>
              <input
                type="text"
                id="aadharNo"
                name="aadharNo"
                value={formData.aadharNo}
                onChange={handleInputChange}
                placeholder="Enter your Aadhar number"
              />
            </div>
            <div className="form-group">
              <label htmlFor="collegeRollNo">College Roll Number</label>
              <input
                type="text"
                id="collegeRollNo"
                name="collegeRollNo"
                value={formData.collegeRollNo}
                onChange={handleInputChange}
                placeholder="Enter your college roll number"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email ID</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="additionalSubject">Subject</label>
              <select
                id="additionalSubject"
                name="additionalSubject"
                value={formData.additionalSubject}
                onChange={handleInputChange}
                required
              >
                <option value="">Select a subject</option>
                <option value="Environment Education">Environment Education</option>
                <option value="Peace Education">Peace Education</option>
                <option value="Health & Physical Education">Health & Physical Education</option>
              </select>
            </div>
          </>
        )}

        <button type="submit" className="submit-button">
          Pay Fees
        </button>
      </form>
    </div>
  );
};

export default Billing;
